import React from 'react';
import styles from './FBMDashboard.module.scss';
import { Col, Container, Row } from 'reactstrap';
import DynamicTable from '../../../components/common/DynamicTable/DynamicTable';
import { customStyles, financialColumns, financialData, inventoryColumns, inventoryData, metricsColumns, metricsData, salesColumns, salesData, shippingColumns, shippingData } from './fbmDashboardData';

const FBMDashboard = () => {
    return (
        <div className={styles.mainFBMDashboardContainer}>
            <h4 className={styles.mainHeading}>Dashboard</h4>

            <Row className={styles.tablesDataRow}>
                <Col xs='12' lg={9} className={styles.tableDataFirstColumn}>
                    <h5 className={styles.sectionHeading}>Sales Performance</h5>

                    <Container fluid className={styles.mainTableContainer}>
                        <div className={styles.dataTableContainer}>
                            <DynamicTable
                                columns={salesColumns}
                                data={salesData}
                                customStyles={customStyles}
                                isPagination={false}
                            />
                        </div>
                    </Container>
                </Col>
                <Col xs='12' lg={3} className={styles.tableDataSecondColumn}>
                    <h5 className={styles.sectionHeading}>Announcement</h5>
                    <Container fluid className={styles.secondDataContainer}>
                        <p>No data</p>
                    </Container>
                </Col>
            </Row>

            <Row className={styles.tablesDataRow}>
                <Col xs='12' lg={9} className={styles.tableDataFirstColumn}>
                    <h5 className={styles.sectionHeading}>Inventory Status</h5>

                    <Container fluid className={styles.mainTableContainer}>
                        <div className={styles.dataTableContainer}>
                            <DynamicTable
                                columns={inventoryColumns}
                                data={inventoryData}
                                customStyles={customStyles}
                                isPagination={false}
                            />
                        </div>
                    </Container>
                </Col>
                <Col xs='12' lg={3} className={styles.tableDataSecondColumn}>
                    <h5 className={styles.sectionHeading}>Tasks</h5>
                    <Container fluid className={styles.secondDataContainer}>
                        <p>No data</p>
                    </Container>
                </Col>
            </Row>

            <Row className={styles.tablesDataRow}>
                <Col xs='12' lg={6} className={styles.tableDataFirstColumn}>
                    <h5 className={styles.sectionHeading}>Customer Metrices</h5>

                    <Container fluid className={styles.mainTableContainer}>
                        <div className={styles.dataTableContainer}>
                            <DynamicTable
                                columns={metricsColumns}
                                data={metricsData}
                                customStyles={customStyles}
                                isPagination={false}
                            />
                        </div>
                    </Container>
                </Col>
                <Col xs='12' lg={6} className={styles.tableDataFirstColumn}>
                    <h5 className={styles.sectionHeading}>Shipping and Fulfillment</h5>

                    <Container fluid className={styles.mainTableContainer}>
                        <div className={styles.dataTableContainer}>
                            <DynamicTable
                                columns={shippingColumns}
                                data={shippingData}
                                customStyles={customStyles}
                                isPagination={false}
                            />
                        </div>
                    </Container>
                </Col>
            </Row>

            <Row className={styles.tablesDataRow}>
                <Col xs='12' lg={9} className={styles.tableDataFirstColumn}>
                    <h5 className={styles.sectionHeading}>Financial Overview</h5>

                    <Container fluid className={styles.mainTableContainer}>
                        <div className={styles.dataTableContainer}>
                            <DynamicTable
                                columns={financialColumns}
                                data={financialData}
                                customStyles={customStyles}
                                isPagination={false}
                            />
                        </div>
                    </Container>
                </Col>
            </Row>
        </div>
    )
}

export default FBMDashboard;